export default "__VITE_ASSET__1ebfe55c__"